<template>
  <div class="administrator">
    <div class="admin-search">
      <div class="search-left">
        <el-button type="primary" @click="refreshMember"> 同步企微成员 </el-button>
        <span class="total">共 {{ totalNumber }} 个成员</span>
      </div>
      <div class="search-right">
        <el-button type="text" @click="dialogVisible = true"> 如何添加成员？ </el-button>
        <div class="search-content">
          <div>
            <span>角色：</span>
            <el-select
              v-model="params.role"
              placeholder="请选择"
              class="m-r-6"
              @change="searchUser"
            >
              <el-option key="all" label="全部" value="" />
              <el-option
                v-for="item in rolesList"
                :key="item.role_id"
                :label="item.role_name"
                :value="item.role_id"
              />
            </el-select>
          </div>
          <div>
            <el-input
              v-model="params.username"
              placeholder="成员名称"
              class="input-m"
              clearable
              @change="searchUser"
            >
              <el-button slot="append" icon="el-icon-search" @click="searchUser" />
            </el-input>
          </div>
        </div>
      </div>
    </div>

    <div class="admin-content">
      <el-card class="box-card menu">
        <div class="tips">若员工数据和企业微信不一致，请检查是否在企业微信将全部部门授权给商派</div>
        <div class="tree">
          <el-tree
            ref="tree"
            v-loading="treeLoading"
            :data="departmentTree"
            node-key="id"
            default-expand-all
            :expand-on-click-node="false"
            highlight-current
            :props="defaultProps"
            @node-click="handleNodeClick"
          >
            <span slot-scope="{ data }" class="custom-tree-node">
              <span>
                <div class="pic-folder" />
                {{ data.name }}
              </span>
              <el-button
                v-if="data.sync_is_rel === 0"
                type="text"
                size="mini"
                @click="() => check(data)"
              >
                同步设置
              </el-button>
              <el-button
                v-if="data.sync_is_rel === 1"
                type="text"
                size="mini"
                @click="() => check(data)"
              >
                已设置
              </el-button>
            </span>
          </el-tree>
        </div>
      </el-card>
      <el-card class="box-card list f-table-block">
        <el-table
          ref="multipleTable"
          v-loading="tableloading"
          :data="userList"
          style="width: 100%"
          tooltip-effect="dark"
        >
          <el-table-column label="成员名称">
            <template slot-scope="scope">
              <div class="member">
                <div class="member-image">
                  <img v-if="scope.row.avatar" :src="scope.row.avatar" alt="" srcset="" />
                  <img v-else src="@/assets/img/default_avatar.png" alt="" />
                </div>
                <div class="member-info">
                  <div class="member-name">
                    {{ scope.row.user_name }}
                  </div>
                  <div v-if="scope.row.alias" class="member-alias">别名：{{ scope.row.alias }}</div>
                </div>
              </div>
            </template>
          </el-table-column>

          <el-table-column>
            <template slot="header">
              <span>账号(userid)</span>
              <el-tooltip
                effect="dark"
                content="userid，对应成员在企业微信管理端的账号"
                placement="top"
              >
                <i class="el-icon-info tooltip" />
              </el-tooltip>
            </template>
            <template slot-scope="scope">
              <span>{{ scope.row.work_userid }}</span>
            </template>
          </el-table-column>

          <el-table-column prop="name" label="所在部门" :show-overflow-tooltip="true">
            <template slot-scope="scope">
              <ul
                v-for="(item, index) in scope.row.department"
                :key="index"
                class="department-list"
              >
                <li>{{ item }}</li>
              </ul>
            </template>
          </el-table-column>
          <el-table-column>
            <template slot="header">
              <span>激活状态</span>
              <el-tooltip effect="dark" content="成员在企业微信中的激活状态" placement="top">
                <i class="el-icon-info tooltip" />
              </el-tooltip>
            </template>
            <template slot-scope="scope">
              <span>{{ listState[scope.row.state] }}</span>
            </template>
          </el-table-column>
          <el-table-column label="角色">
            <template slot-scope="scope">
              <span>{{ scope.row.role || '普通员工' }}</span>
            </template>
          </el-table-column>
          <el-table-column label="操作">
            <template slot-scope="scope">
              <el-button
                type="text"
                :disabled="scope.row.type == 'admin'"
                @click="setRole(scope.row)"
              >
                管理权限
              </el-button>
            </template>
          </el-table-column>
        </el-table>

        <el-pagination
          class="table-pagination"
          background
          :current-page="params.page"
          :page-sizes="[10, 20, 50, 100]"
          :page-size="params.page_size"
          layout="total, sizes, prev, pager, next, jumper"
          :total="total_count"
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
        />
      </el-card>
    </div>

    <el-dialog title="添加企业成员" :visible.sync="dialogVisible" width="550px">
      <div class="add-tips">
        <div class="tips">
          列表中显示的成员均为企业微信授权给商派的成员，如需添加请前往企业微信后台授权。
        </div>
        <div class="tips-content">
          <span>
            1. 进入企业微信管理后台，依次进入「应用管理」-「应用」-「自建应用」下的云店应用。
          </span>
          <img class="tips-image" src="@/assets/img/admin1.png" alt="" />
          <span>
            2.
            打开商派云店，点击「编辑」，在「使用范围」内修改或添加成员，如果无法找到需要添加的成员，请先邀请员工加入企业。
          </span>
          <img class="tips-image" src="@/assets/img/admin2.png" alt="" />
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="dialogVisible = false">我知道了</el-button>
      </span>
    </el-dialog>

    <el-dialog title="权限设置" :visible.sync="permissionsVisible" width="550px">
      <div class="permissions-setting">
        <div class="label">设置角色：</div>
        <div class="setting">
          <el-select
            v-model="setRoleData"
            placeholder="请选择"
            class="select"
            @change="setRolechange"
          >
            <el-option
              v-for="item in setRoleList"
              :key="item.role_id"
              :label="item.role_name"
              :value="item.role_id"
            />
          </el-select>
          <div class="setting-tips">
            <span v-if="roleStr === '管理员'">拥有系统全部权限</span>
            <span v-if="roleStr === '普通员工'">无系统任何权限，无法登陆系统</span>
          </div>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="permissionsVisible = false">取 消</el-button>
        <el-button type="primary" @click="submitRole">确 定</el-button>
      </span>
    </el-dialog>

    <el-dialog title="设置自动同步" :visible.sync="checkVisible" width="40%">
      <!-- <span v-if="checkData">部门:&nbsp;&nbsp;{{ checkData.department }}</span> -->
      <el-form ref="form" :model="form" label-width="180px">
        <el-form-item label="成员类型:">
          <el-radio-group v-model="form.resource">
            <el-radio label="员工"></el-radio>
            <el-radio label="编外"></el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="关联门店:">
          <div v-if="checkData.rel_info">
            <div>{{ checkData.rel_info.store_name }}&nbsp;&nbsp;</div>
            <div>编号: {{ checkData.rel_info.store_bn }}&nbsp;&nbsp;</div>
          </div>
          <el-button type="text" @click="changeStore">设置门店</el-button>
        </el-form-item>
      </el-form>

      <span slot="footer" class="dialog-footer">
        <el-button @click="checkVisible = false">取消</el-button>
        <el-button v-if="checkData.rel_id" type="primary" @click="deleteSync"
          >取消自动同步</el-button
        >
        <el-button type="primary" @click="confirmSync">确定同步</el-button>
      </span>
    </el-dialog>
    <!-- 编辑门店对话框 -->
    <SyncShop v-model="storeVisible" :select-data="selectStoreData" @chooseStore="chooseStore" />
  </div>
</template>

<script>
import SyncShop from '@/components/syncShop/index.vue'
export default {
  data() {
    return {
      dialogVisible: false,
      permissionsVisible: false,
      rolesList: [],
      setRoleList: [],
      userList: [],
      tableloading: false,
      total_count: 100,
      params: {
        page: 1,
        page_size: 20,
        role: '',
        username: ''
      },
      defaultProps: {
        children: 'subset',
        label: 'label'
      },
      treeLoading: false,
      departmentTree: [],
      updateItem: {},
      totalNumber: 0,
      setRoleData: '',
      roleStr: '',
      listState: {
        1: '已激活',
        2: '已禁用',
        4: '未激活',
        5: '退出企业'
      },
      checkVisible: false,
      checkData: [],
      storeVisible: false, //选择门店的对话框展示
      selectStoreData: [], //选择门店数据,
      syncStore: null,
      form: {
        resource: ''
      }
    }
  },
  components: {
    SyncShop
  },
  mounted() {
    this.getDepartmentData()
    this.getRolesList()
  },
  methods: {
    // 获取部门数据
    async getDepartmentData() {
      this.treeLoading = true
      this.searchDepartment = ''
      const datas = await this.$api.component.getDepartment().catch(() => {
        this.treeLoading = false
      })

      if (datas) {
        this.departmentTree = datas
        //设置首次默认选中第一个
        let currentKey = datas[0].id
        this.$nextTick(() => {
          this.params.department_id = currentKey
          this.$refs.tree.setCurrentKey(currentKey)
          this.getUser('first')
        })
        this.treeLoading = false
      }
    },
    // 获取部门用户列表
    async getUser(type) {
      this.tableloading = true
      const data = await this.$api.component.getDepartmentUser(this.params).catch(() => {
        this.tableloading = false
      })
      if (data) {
        this.userList = data.list
        this.total_count = data.total_count
        this.tableloading = false
        if (type === 'first') {
          this.totalNumber = data.total_count
        }
      }
    },
    // 获取角色列表
    async getRolesList() {
      const data = await this.$api.setting.getRolesList({
        page: 1,
        page_size: 1000
      })
      if (data) {
        this.rolesList = data.list
        this.setRoleList = data.list.filter((v) => v.role_name !== '超级管理员')
      }
    },
    // 列表分页
    handleSizeChange(val) {
      this.params.page = 1
      this.params.page_size = val
      this.getUser()
    },
    handleCurrentChange(val) {
      this.params.page = val
      this.getUser()
    },
    handleNodeClick(data) {
      this.params.department_id = data.id
      this.getUser()
    },

    // 同步员工
    async refreshMember() {
      this.$message('正在同步成企微成员，请耐心等待。')
      const data = await this.$api.setting.syncDepartment()
      if (data) {
        this.$message({
          message: '成员已同步完成。',
          type: 'success'
        })
        this.getDepartmentData()
      }
    },

    // 查询列表
    searchUser() {
      this.params.page = 1
      this.getUser()
    },

    // 设置角色
    setRole(item) {
      this.permissionsVisible = true
      this.updateItem = item
    },

    // 修改用户角色
    async submitRole() {
      let userId = this.updateItem.user_id
      this.permissionsVisible = false
      const data = await this.$api.setting.updateRole(userId, {
        role: [this.setRoleData]
      })
      if (data) {
        this.$message({
          message: '修改成功',
          type: 'success'
        })
        this.getUser()
      }
    },

    setRolechange(item) {
      let role_str = this.rolesList.filter((v) => v.role_id === item)
      this.roleStr = role_str[0].role_name
    },
    async check(data) {
      this.syncStore = data.id
      const datas = await this.$api.component.getrel({ department_id: data.id })
      if (datas) {
        this.checkData = datas
        if (this.checkData.salesperson_type === 1) {
          this.form.resource = '员工'
        } else if (this.checkData.salesperson_type === 2) {
          this.form.resource = '编外'
        } else {
          this.form.resource = ''
        }
      }
      this.checkVisible = true
    },
    // 选择门店
    chooseStore(selectdata, result) {
      if (selectdata.store_id && result[0]) {
        this.selectdata = selectdata
        this.checkData.rel_info = selectdata
      } else {
        this.checkData = {
          id: this.checkData.id
        }
      }
      this.result = result

      this.storeVisible = false
    },
    sync(data) {
      this.syncStore = data.id
      this.storeVisible = true
    },
    async deleteSync() {
      const datas = await this.$api.component.delrel({ id: this.checkData.id })
      if (datas) {
        setTimeout(() => {
          this.$message.success('取消成功')
          this.checkVisible = false
          this.storeVisible = false
          this.getDepartmentData()
        }, 1000)
      }
    },
    changeStore() {
      this.selectStoreData = []
      this.selectStoreData.push(this.checkData.rel_info)
      this.storeVisible = true
    },
    async confirmSync() {
      if (this.result && this.result.length === 0) {
        this.deleteSync()
      } else {
        let result = null
        if (this.form.resource === '员工') {
          result = 1
        }
        if (this.form.resource === '编外') {
          result = 2
        }
        if (!this.selectdata && !this.result && Array.isArray(this.checkData)) {
          return this.$message.error('请选择门店')
        } else {
          const params = {
            department_id: this.syncStore,
            rel_id:
              (this.selectdata && this.selectdata.store_id) ||
              result[0] ||
              this.checkData.rel_info.store_id,
            rel_type: 'store',
            salesperson_type: result
          }

          const datas = await this.$api.component.saverel(params)
          if (datas) {
            setTimeout(() => {
              this.$message.success('同步成功')
              this.storeVisible = false
              this.checkVisible = false
              this.getDepartmentData()
            }, 1000)
          }
        }
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.administrator {
  .tips {
    padding: 8px 16px;
    border-radius: 2px;
    background-color: rgba(238, 248, 255, 1);
    border: 1px solid rgba(217, 236, 255, 1);
    color: #595959;
    font-size: 12px;
    margin-bottom: 20px;
  }
  .add-tips {
    .tips-content {
      height: 500px;
      overflow: auto;
      margin-bottom: 15px;
      .tips-image {
        width: 100%;
      }
    }
  }

  .admin-search {
    display: flex;
    justify-content: space-between;
    margin-bottom: 20px;
    .search-left {
      width: 300px;
      margin-right: 20px;
      .total {
        margin-left: 15px;
      }
    }
    .search-right {
      flex: 1;
      display: flex;
      justify-content: space-between;
      .search-content {
        display: flex;
      }
    }
  }

  .admin-content {
    display: flex;
    .menu {
      width: 300px;
      height: calc(100vh - 180px);
      overflow: auto;
      margin-right: 20px;
      ::v-deep {
        .el-card__header {
          border-bottom: none;
          padding: 18px 20px 0;
        }
      }

      .tree {
        ::v-deep {
          .el-tree-node:focus > .el-tree-node__content {
            background-color: rgba(230, 247, 255, 1) !important;
          }
          .el-tree-node__content:hover {
            background-color: rgba(230, 247, 255, 1);
          }
          .el-tree--highlight-current .el-tree-node.is-current > .el-tree-node__content {
            background-color: rgba(230, 247, 255, 1);
          }
        }

        .custom-tree-node {
          flex: 1;
          display: flex;
          align-items: center;
          justify-content: space-between;
          > span {
            display: flex;
            align-items: center;

            .pic-folder {
              display: inline-block;
              width: 16px;
              height: 16px;
              background: url('../../assets/img/folder.png') no-repeat;
              background-size: contain;
              margin-right: 4px;
            }
          }
        }
      }
    }
    .list {
      flex: 1;
      height: calc(100vh - 180px);
      overflow: auto;
    }
    .f-table-block {
      padding: 0;
    }
  }

  // 权限设置
  .permissions-setting {
    display: flex;
    justify-content: center;
    .label {
      line-height: 36px;
    }
    .setting {
      .select {
        width: 300px;
      }
      .setting-tips {
        color: #909399;
        font-size: 12px;
        margin-top: 10px;
      }
    }
  }

  .member {
    display: flex;
    align-items: center;
    .member-image {
      width: 32px;
      height: 32px;
      img {
        width: 100%;
        height: 100%;
        border-radius: 4px;
      }
    }
    .member-info {
      display: flex;
      flex: 1;
      flex-direction: column;
      justify-content: center;
      margin-left: 10px;
      .member-name {
        line-height: 22px;
        font-size: 14px;
        text-overflow: -o-ellipsis-lastline;
        overflow: hidden;
        text-overflow: ellipsis;
        display: -webkit-box;
        -webkit-line-clamp: 2;
        line-clamp: 2;
        -webkit-box-orient: vertical;
      }
      .member-alias {
        font-size: 12px;
        color: #909399;
        line-height: 14px;
      }
    }
  }
  .tooltip {
    cursor: pointer;
    margin-left: 4px;
    font-size: 14px;
    color: #ccc;
  }

  .department-list {
    width: 100%;
    li {
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }
  }
  .box {
    display: flex;
    align-items: center;
  }
  .mt20 {
    margin-top: 20px;
  }
}
</style>
